import ConsensiListPage from "./pages/ConsensiListPage.vue";
import ConsensiEditPage from './pages/ConsensiEditPage.vue'
import ConsensiViewPage from './pages/ConsensiViewPage.vue'
export default {
    ConsensiListPage,
    ConsensiEditPage,
    ConsensiViewPage
}
